module.exports = __webpack_public_path__ + "img/title-2.cfcc8661.png";